var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddress = function SvgAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.318 9.148c1.006 0 1.83-.824 1.83-1.83 0-1.006-.824-1.83-1.83-1.83-1.006 0-1.83.824-1.83 1.83 0 1.006.824 1.83 1.83 1.83Zm0-9.148c3.842 0 7.318 2.946 7.318 7.5 0 2.91-2.241 6.331-6.714 10.274a.93.93 0 0 1-1.217 0C2.241 13.83 0 10.41 0 7.5 0 2.945 3.476 0 7.318 0Z",
    fill: "#D2AB67"
  })));
};
export default SvgAddress;